import { ref } from 'vue'

export const useToogle = (initialValue = false) => {
  const bool = ref(initialValue)

  const toogle = () => {
    bool.value = !bool.value
  }

  return [bool, toogle]
}
